import React, { useRef, useState } from 'react';
import { FiImage, FiUpload } from 'react-icons/fi';
import { adminApi } from '../adminApi';
import { showAlert } from '../utils/dialog';

export default function ImageUpload({ value, onChange, label = 'Image', hint, height = 110, uploadOnly = false, type = 'product' }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const r = await adminApi.uploadImage(file, type);
      onChange(r.data.url);
    } catch {
      showAlert('Upload failed. Use JPG, PNG or WebP under 10 MB.');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div className="admin-form-group">
      {label && <label>{label}</label>}

      {/* Preview */}
      {value && (
        <img
          src={value} alt=""
          style={{ width: '100%', height, objectFit: 'cover', borderRadius: 8, marginBottom: 8, border: '1.5px solid var(--border)', display: 'block' }}
          onError={e => { e.target.style.display = 'none'; }}
        />
      )}

      {/* Hidden file input */}
      <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFile} />

      {/* Upload button */}
      <button
        type="button"
        onClick={() => fileRef.current?.click()}
        disabled={uploading}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
          width: '100%', padding: '10px 14px', marginBottom: 8,
          border: '1.5px dashed var(--border)', borderRadius: 8,
          background: 'var(--bg)', color: 'var(--text-muted)',
          cursor: uploading ? 'wait' : 'pointer', fontSize: '.875rem',
          fontFamily: 'inherit', transition: 'all .15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.color = 'var(--accent)'; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--text-muted)'; }}
      >
        {uploading
          ? <><FiUpload size={14} /> Uploading…</>
          : <><FiImage size={14} /> {value ? 'Replace image' : 'Upload from computer'}</>
        }
      </button>

      {!uploadOnly && (
        <input
          value={value ?? ''}
          onChange={e => onChange(e.target.value)}
          placeholder="Or paste image URL…"
          style={{ width: '100%', padding: '10px 13px', border: '1.5px solid var(--border)', borderRadius: 8, fontSize: '.875rem', fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box', background: 'var(--surface)', color: 'var(--text)' }}
        />
      )}
      {hint && <div style={{ fontSize: '.75rem', color: 'var(--text-muted)', marginTop: 4 }}>{hint}</div>}
    </div>
  );
}
